import { useEffect } from 'react';
import { useKeyboardShortcuts } from '../../KeyboardShortcuts/hooks/useKeyboardShortcuts';

export function useListenInvertAppColorChange(handler: () => void) {
  const { getActionsByKeyEvent } = useKeyboardShortcuts();

  useEffect(() => {
    function keyboardListener(event: KeyboardEvent) {
      const { actions } = getActionsByKeyEvent(event);
      if (actions.includes('invertAppColors')) {
        handler();
        event.preventDefault();
      }
    }
    document.body.addEventListener('keydown', keyboardListener);
    return () => {
      document.body.removeEventListener('keydown', keyboardListener);
    };
  }, [getActionsByKeyEvent, handler]);
}
